// extracted by mini-css-extract-plugin
export default {"checkBox":"PostServiceList_checkBox__xcE39"};